<template>
  <el-form
      label-position="left"
      ref="form"
      :model="form"
      :disabled="disabledForm"
      :rules="rules"
      size="mini">
<!--      <el-col :span="4">-->
<!--        <el-form-item label="Received Date" prop="receivedDate">-->
<!--          <el-date-picker-->
<!--              style="width: 100%"-->
<!--              v-model="form.receivedDate"-->
<!--              :clearable='false'-->
<!--              format="d MMM yy"-->
<!--              value-format="MM-dd-yyyy"-->
<!--              type="date"-->
<!--              placeholder="Select Date">-->
<!--          </el-date-picker>-->
<!--        </el-form-item>-->
<!--      </el-col>-->
        <el-form-item class="label-without-start" label-width="150px" label="Payment Method *" prop="paymentMethodId">
          <el-select
              no-data-text="no date"
              placeholder="Select Payment Method"
              class="select"
              @change="changePaymentMethod"
              v-model="form.paymentMethodId"
          >
            <el-option
                v-for="item in paymentMethodList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="label-without-start" label-width="150px" label="Deposit Account *" prop="depositAccountId">
          <el-select
              no-data-text="no date"
              placeholder="Select Deposit Account"
              class="select"
              :disabled="!form.paymentMethodId"
              v-model="form.depositAccountId"
          >
            <el-option
                v-for="item in depositAccountList"
                :key="item.id"
                :disabled="!item.active"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
<!--    <el-form-item label-width="150px" label="Balance to Received" prop="balanceToReceived">-->
<!--      <el-input placeholder="Balance to Received" v-model="form.balanceToReceived" style="width: 100%; max-width: 155px;" ></el-input>-->
<!--        </el-form-item>-->
        <el-form-item label-width="150px" label="Amount Received" prop="amountReceived">
          <money style="width: auto;" v-model="form.amountReceived" :disabled="disabledForm" @keydown.native="$event.key === '-' ? $event.preventDefault() : null" v-bind="money" @change.native="$emit('calculateResults')"></money>
        </el-form-item>
    <el-form-item label-width="150px" label="Cheque / Ref #" prop="chequeRefNo">
      <el-input placeholder="Cheque Vaucher/Ref #" v-model="form.chequeRefNo" style="width: 100%; max-width: 155px;" >
      </el-input>
    </el-form-item>
  </el-form>
</template>

<script>
import { Money } from 'v-money'

export default {
  name: "SinglePaymentMethod",
  components: {
    Money
  },
  data() {
    return {
      form: {
        // receivedDate: null,
        paymentMethodId: null,
        balanceToReceived: null,
        depositAccountId: null,
        chequeRefNo: null,
        // receivedBy: null,
        amountReceived: 0
      },
      rules: {
        // receivedDate: [{
        //   required: true,
        //   message: this.$i18n.t('modal_settings_fieldIsRequired'),
        //   trigger: 'change'
        // }],
        paymentMethodId: [{
          required: true,
          message: this.$i18n.t('modal_settings_fieldIsRequired'),
          trigger: 'change'
        }],
        depositAccountId: [{
          required: true,
          message: this.$i18n.t('modal_settings_fieldIsRequired'),
          trigger: 'change'
        }],
        // receivedBy: [{
        //   required: true,
        //   message: this.$i18n.t('modal_settings_fieldIsRequired'),
        //   trigger: 'change'
        // }],
      },
      depositAccountList: [],
      money: {
        precision: 2,
        decimal: '.',
        thousands: ','
      },
    }
  },
  props: {
    paymentMethodList: {
      type: Array,
      default: () => ([])
    },
    disabledForm: {
      type:Boolean,
      default: false
    }
    // receivedByList: {
    //   type: Array,
    //   default: () => ([])
    // }
  },
  // computed: {
  //   receivedByListChanged() {
  //     return this.receivedByList.filter(val => val.isChequeReceipts)
  //   }
  // },
  methods: {
    changePaymentMethod() {
      const pm = this.paymentMethodList.find(item => item.id === this.form.paymentMethodId)
      if (pm) {
        this.depositAccountList = pm.accounts
        this.form.depositAccountId = null
      } else {
        this.depositAccountList = []
        this.form.depositAccountId = null
      }
    },
    validate() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          console.log('======', valid)
          resolve(valid)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-input {
  width: 100%;
}
/deep/.label-without-start {
  :before {
    display: none;
  }
}
</style>